import React from 'react'
import { components } from 'react-select'

import { ReactComponent as ClearIcon } from '../../../../../assets/svgs/clear.svg'
import { IconGenerator } from '../../IconGenerator'
import * as S from '../styles'

import type { ClearIndicatorComponentProps } from './types'
import type { ReactElement } from 'react'

export const ClearIndicator = <T,>(
  props: ClearIndicatorComponentProps<T>
): ReactElement => {
  const {
    selectProps: { hasDropdown = true },
  } = props
  return (
    <components.ClearIndicator {...props}>
      <S.ClearContainer $hasDropdown={hasDropdown}>
        <IconGenerator iconComponent={ClearIcon} width={18} height={18} />
      </S.ClearContainer>
    </components.ClearIndicator>
  )
}
